export default __webpack_public_path__ + "_/shared_modules/sprites/dist/sprite-banner-9b779e0ec0a18c1d7855beed69be56ab.png";